import { useState } from 'react';

import type {
  DesignBuilding,
  Structure,
} from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

export const useDesignConfig = ({
  building,
}: {
  building: DesignBuilding | undefined;
}): {
  designConfig: Structure;
  updateDesignConfig: () => void;
} => {
  const [designConfig, setDesignConfig] = useState<Structure>({});
  const updateDesignConfig = () => {
    if (!building) {
      return;
    }
    /**
     * The object returned by .to_config(), keeps the same reference. We JSON parse and stringify
     * in order make a new object reference. We do this otherwise this won't work as expected: for useMemo(..., [designConfig]) to work expected.
     */
    setDesignConfig(
      JSON.parse(
        JSON.stringify(building.designer.get_active_design().to_config()),
      ) as Structure,
    );
  };

  return {
    designConfig,
    updateDesignConfig,
  };
};
